import getBaseDisplayLabel from './getBaseDisplayLabel';
import utils from '../utils';
import context from '../context';
import { ALL_DAY, DISPLAY_MODES } from '../constants';
import gettext from '../lang/gettext';

export default function getLeaveDisplayLabel(leave, displayMode, days) {
  if (leave.fullDay) {
    return gettext(ALL_DAY);
  }

  if (displayMode === DISPLAY_MODES.DAY) {
    return getLabelForDayMode(leave, days);
  }

  return getLabelForWeekAndMonthModes(leave);
}

function getLabelForDayMode(leave, days) {
  const { visibleHoursStart, visibleHoursEnd } = context.orgSettings;
  const businessDay = utils.getBusinessDayForCalendar(visibleHoursStart, visibleHoursEnd, days[0]);

  if (leave.dtstart <= businessDay.visibleStart && leave.dtend >= businessDay.visibleEnd) {
    return gettext(ALL_DAY);
  }

  let start = leave.dtstart;
  let end = leave.dtend;

  if (leave.dtstart < businessDay.visibleStart) {
    start = businessDay.visibleStart;
  }

  if (leave.dtend > businessDay.visibleEnd) {
    const nextBusinessDayStart = utils.addDays(businessDay.visibleStart, 1);
    if (leave.dtend > nextBusinessDayStart) {
      end = businessDay.visibleEnd;
    } else {
      end = leave.dtend;
    }
  }

  return getFormattedLabel(start, end);
}

function getLabelForWeekAndMonthModes(leave) {
  const { visibleHoursStart, visibleHoursEnd } = context.orgSettings;

  if (leave.currentDisplayDate) {
    const day = new Date(leave.currentDisplayDate);
    const businessDay = utils.getBusinessDayForCalendar(visibleHoursStart, visibleHoursEnd, day);

    if (leave.dtstart <= businessDay.visibleStart && leave.dtend >= businessDay.visibleEnd) {
      return gettext(ALL_DAY);
    }

    if (leave.dtstart <= businessDay.visibleStart && leave.dtend >= businessDay.visibleEnd) {
      return gettext(ALL_DAY);
    }

    if (!leave.isMultiDay) {
      return getFormattedLabel(leave.dtstart, leave.dtend);
    } else if (utils.formatDate(leave.dtstart) === utils.formatDate(day)) {
      return getFormattedLabel(leave.dtstart, businessDay.visibleEnd);
    }

    if (leave.isLastOccurence) {
      return getFormattedLabel(businessDay.visibleStart, leave.dtend);
    }

    const nextDay = utils.addDays(day, 1);
    if (leave.dtstart < day && leave.dtend > nextDay) {
      return gettext(ALL_DAY);
    }

    if (leave.dtstart > day && leave.dtend > nextDay) {
      return getFormattedLabel(leave.dtstart, businessDay.visibleEnd);
    }

    if (leave.dtstart < day && leave.dtend < nextDay) {
      return getFormattedLabel(day, leave.dtend);
    }
  }

  const { usTimeFormat } = context;
  const durationInMinutes =
    typeof leave.duration !== 'undefined'
      ? leave.duration * 60
      : (leave.dtend - leave.dtstart) / 1000 / 60;
  const decimalFormat = context.getDecimalFormat();
  const displayDuration = utils.getDisplayDuration(durationInMinutes, decimalFormat);
  return `${getBaseDisplayLabel(leave.dtstart, leave.dtend, usTimeFormat)} • ${displayDuration}`;
}

function getFormattedLabel(start, end) {
  const { usTimeFormat } = context;
  const durationInMinutes = (end - start) / 1000 / 60;
  const decimalFormat = context.getDecimalFormat();
  const displayDuration = utils.getDisplayDuration(durationInMinutes, decimalFormat);

  if (durationInMinutes >= 1440) {
    // 24hours
    return gettext(ALL_DAY);
  }
  return `${getBaseDisplayLabel(start, end, usTimeFormat)} • ${displayDuration}`;
}
